import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { channelAPI } from '../api/channel';

const Channels = () => {
  const navigate = useNavigate();
  const [recommended, setRecommended] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
      return;
    }

    loadChannels();
  }, [navigate]);

  const loadChannels = async () => {
    try {
      const token = localStorage.getItem('token');
      const data = await channelAPI.getRecommendedChannels(token);
      setRecommended(data);
    } catch (err) {
      console.error('Failed to load channels:', err);
    } finally {
      setLoading(false);
    }
  };

  const goToCreateChannel = () => {
    navigate('/channels/create');
    setTimeout(() => {
      if (!window.location.href.includes('channels/create')) {
        window.location.assign(`${window.location.origin}/#/channels/create`);
      }
    }, 0);
  };

  const handleSubscribe = async (channelId) => {
    try {
      const token = localStorage.getItem('token');
      await channelAPI.subscribe(token, channelId);
      loadChannels();
    } catch (err) {
      console.error('Failed to subscribe:', err);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-xl text-gray-600">Загрузка...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white border-b border-gray-200 px-4 py-4">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-bold" style={{ color: '#6B5CE7' }}>Рекомендации</h1>
          <button onClick={goToCreateChannel} className="px-4 py-2 bg-gradient-to-r from-purple-600 to-blue-600 text-white rounded-lg font-semibold">
            Создать канал
          </button>
        </div>
      </div>

      <div className="p-4">
        {recommended.length === 0 ? (
          <div className="text-center py-8">
            <p className="text-gray-600">Нет рекомендаций</p>
          </div>
        ) : (
          <div className="space-y-3">
            {recommended.map((channel) => (
              <div key={channel.id} className="bg-white rounded-lg shadow p-4">
                <div className="flex items-center gap-4">
                  <div className="w-16 h-16 bg-gradient-to-r from-purple-600 to-blue-600 rounded-full flex items-center justify-center text-white text-2xl font-bold">
                    {channel.name.charAt(0).toUpperCase()}
                  </div>
                  <div className="flex-1">
                    <h3 className="font-bold text-lg">{channel.name}</h3>
                    {channel.description && <p className="text-gray-600 text-sm">{channel.description}</p>}
                    <p className="text-gray-500 text-sm">{channel.subscribers_count} подписчиков</p>
                  </div>
                  <button
                    onClick={() => handleSubscribe(channel.id)}
                    className="px-6 py-2 bg-gradient-to-r from-purple-600 to-blue-600 text-white rounded-lg hover:opacity-90 transition font-semibold"
                  >
                    Подписаться
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Channels;
